'use client';

import Link from 'next/link';
import Logo from '@/components/common/logo';
import Actions from './actions';
import { MobileDrawer } from './mobile-drawer';
import { SearchBar } from './search-bar';
import { ShopNavigation } from './shop-navigation';
interface HeaderProps {
  banner?: string;
  shopNavigation?: boolean;
}
export const Header = ({
  banner,
  shopNavigation
}: HeaderProps) => {
  return <header className="sticky bg-white top-0 z-20" data-sentry-component="Header" data-sentry-source-file="index.tsx">
      {banner && <p className="flex h-10 items-center justify-center bg-primary px-4 text-sm font-medium text-white sm:px-6 lg:px-8">
          {banner}
        </p>}

      <nav aria-label="Top" className="mx-auto px-2 sm:px-2 lg:px-6 border-b border-gray-200">
        <div className="flex h-header items-center justify-between">
          <MobileDrawer data-sentry-element="MobileDrawer" data-sentry-source-file="index.tsx" />
          <div className="flex gap-6 items-center">
            <Logo data-sentry-element="Logo" data-sentry-source-file="index.tsx" />
            <Link href="https://about.shopzaars.com/how-it-works" target="_blank" className="mt-4 hidden lg:block hover:text-primary text-md whitespace-nowrap" data-sentry-element="Link" data-sentry-source-file="index.tsx">
              How it works
            </Link>
            <Link href="https://about.shopzaars.com/cloth-and-culture" target="_blank" className="mt-4 hidden lg:block hover:text-primary text-md whitespace-nowrap" data-sentry-element="Link" data-sentry-source-file="index.tsx">
              cloth & culture
            </Link>
            <Link href="https://about.shopzaars.com/our-story" target="_blank" className="mt-4 hidden lg:block hover:text-primary text-md whitespace-nowrap" data-sentry-element="Link" data-sentry-source-file="index.tsx">
              Our Story
            </Link>
          </div>
          <div className="ml-12 h-full items-center flex-1 hidden md:flex">
            <SearchBar data-sentry-element="SearchBar" data-sentry-source-file="index.tsx" />
          </div>
          <div className="flex sm:flex-1 md:flex">
            <Actions data-sentry-element="Actions" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </nav>
      {shopNavigation && <ShopNavigation />}
    </header>;
};